import React, {Fragment, useState} from "react";
import dayjs from "dayjs";

import PageHeaderLayout from "../../layout/pageHeaderLayout";
import useAntTable from "../../utils/useAntTable";
import * as api from "../../apis/bulletin";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import withAuth from "../../utils/withAuth";
import {Button, Divider, Popconfirm, Space} from "antd";
import ModifyModal from "./modifyModal";
import useFormModal from "../../utils/useFormModal";
import * as minio from "../../utils/minio";
import {useRequest} from "ahooks";
import DetailDrawer from "./detailDrawer";
import {useSelector} from "react-redux";
import {RootState} from "../../models";
import {PlatformType} from "../../utils/constants";


const AddButton = withAuth('add', Button)
const EditFragment = withAuth('edit', Fragment)
const PublishFragment = withAuth('publish', Fragment)
const DeletePopconfirm = withAuth('delete', Popconfirm)

function SysBulletin() {

    const platform = useSelector<RootState, RootState['auth']>(state => state.auth)?.user?.platform??PlatformType.Dealer;
    const {tableProps, refresh} = useAntTable(api.getBulletins, {})

    const [selectedBulletin, setSelectedBulletin] = useState<any>()

    const {modalProps, setVisible} = useFormModal({
        onRequest: onSave,
        onOk: () => {
            setVisible(false)
            refresh()
        }
    })

    async function onSave(data: any) {
        if (data.attachments && data.attachments.fileList) {
            const attachments = data.attachments.fileList
            const newAttachments = attachments.map(async (attachment: any) => {
                if (typeof (attachment) != "string" && attachment.status !== 'done') {
                    const fileName = attachment.name.split(".")
                    const extendName = fileName.pop()
                    const path = `bulletin/attachment/${fileName.join(".")}${dayjs(new Date()).format('YYYYMMDDHHmmss')}.${extendName}`
                    return await minio.upload(attachment.originFileObj, path)
                } else {
                    if (attachment.status) {
                        return attachment.name
                    } else {
                        return attachment
                    }
                }
            })
            data.attachments = await Promise.all(newAttachments)
        }
        const content = data.contentRaw
        data.content = content.toHTML()
        data.contentRaw = content.toRAW()
        return api.modifyBulletin(data)
    }

    const {run: onPublish} = useRequest(api.publishBulletin, {
        manual: true, onSuccess: () => {
            refresh();
        }
    })

    const {run: onDelete} = useRequest(api.deleteBulletin, {
        manual: true, onSuccess: () => {
            refresh();
        }
    })

    const columns: StandardColumnsType = [
        {
            title: '主题',
            dataIndex: 'title'
        },
        {
            title: '发布部门',
            dataIndex: 'department'
        },
        {
            title: '状态',
            dataIndex: 'status',
            render: status => status ? '已发布' : '未发布'
        },
        {
            title: '创建人',
            dataIndex: 'createName',
        },
        {
            title: '发布时间',
            dataIndex: 'publishTime',
            render: time => time && dayjs(time).format('lll')
        },
        {
            title: '操作',
            dataIndex: 'operations',
            render: (_, record: any) => (
                <span>
                    {!record.status ? (
                        <Fragment>
                            <EditFragment>
                                <a onClick={() => setVisible(true, record)}>编辑</a>
                                <Divider type={'vertical'}/>
                            </EditFragment>
                            <PublishFragment>
                                <Popconfirm title={'是否确认发布'} onConfirm={() => onPublish(record.id)}>
                                    <a>发布</a>
                                </Popconfirm>
                                <Divider type={'vertical'}/>
                            </PublishFragment>
                            <DeletePopconfirm title={'是否确认删除'} onConfirm={() => onDelete(record.id)}>
                                <a>删除</a>
                            </DeletePopconfirm>
                        </Fragment>
                    ) : (
                        <a onClick={() => setSelectedBulletin(record)}>查看</a>
                    )}
                </span>
            )
        }
    ]

    return (
        <PageHeaderLayout>
            <StandardTable rowKey={'id'} columns={columns} {...tableProps} toolbar={(
                <Space>
                    <AddButton type={'primary'} onClick={() => setVisible(true)}>新增</AddButton>
                </Space>
            )}/>
            <ModifyModal {...modalProps} />
            <DetailDrawer visible={!!selectedBulletin}
                          onClose={() => setSelectedBulletin(undefined)}
                          bulletin={selectedBulletin}
            />
        </PageHeaderLayout>
    )
}

export default SysBulletin
